module.exports = __webpack_public_path__ + "static/media/178-palau.de4751cb.svg";